import React from 'react';
import {
  Pagination as ReactstrapPagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import { withPropsOnChange, compose, onlyUpdateForKeys } from 'recompose';
import { range, map, pick } from 'lodash';

export const Pagination = ({ pages, ...props }) => {
  const paginationProps = pick(props, 'className', 'style', 'size', 'tag');

  return (
    <ReactstrapPagination {...paginationProps}>
      {pages.map(i => (
        <PaginationItem active={i.active} key={i.page}>
          <PaginationLink href="#" onClick={i.onClick}>
            {i.page}
          </PaginationLink>
        </PaginationItem>
      ))}
    </ReactstrapPagination>
  );
};

const enhance = compose(
  onlyUpdateForKeys(['count', 'offset', 'onOffsetChanged', 'limit']),
  withPropsOnChange(
    ['count', 'offset', 'onOffsetChanged', 'limit'],
    ({ count, limit, offset, onOffsetChanged }) => {
      const numPages = Math.ceil(count / limit);
      const currentPage = Math.floor(offset / limit) + 1;
      console.log("wonky ponk");

      return {
        pages: map(range(1, numPages + 1), i => ({
          page: i,
          onClick: e => {
            window.scroll(0,0);
            e.preventDefault();
            return onOffsetChanged((i - 1) * limit);
          },
          active: i === currentPage,
        })),
      };
    }
  )
);

export default enhance(Pagination);



// WEBPACK FOOTER //
// ./src/components/common/Tables/Pagination.jsx